import React from "react";

/* Copyright on the bottom of the footer. */

export default function CopyRight() {
  return (
    <div className="text-sm sm:text-base text-left">
      <span className="block sm:inline">Copyright ©2023 Mentorsity.com</span>
      <span className="block sm:inline sm:ml-6">support@mentorsity.com</span>
    </div>
  );
}
